import { FC } from 'react';
import { JobReviewTabStatus } from '../../constants';
import { selectSelectedReviewTab } from '../confirmJobsSlice';
import { useAppSelector } from 'hooks';

const baseStatusTabs = [
  {
    status: JobReviewTabStatus.NEEDS_REVIEW,
    label: 'Needs review',
    color: '#5687BD'
  },
  {
    status: JobReviewTabStatus.IN_PROGRESS,
    label: 'In progress',
    color: '#FDBE5F'
  },
  {
    status: JobReviewTabStatus.CONFIRMED,
    label: 'Confirmed',
    color: '#6FAF89'
  },
  {
    status: JobReviewTabStatus.SKIPPED,
    label: 'Skipped from pay',
    color: '#AAAAAA'
  },
  {
    status: JobReviewTabStatus.ALL,
    label: 'All',
    color: '#3E556D'
  }
];

interface JobReviewStatusTabsProps {
  onChange: (status: JobReviewTabStatus | null) => void;
  statusCounts: {
    [key in JobReviewTabStatus]: number;
  };
  isJobsLoading?: boolean;
}

const JobReviewStatusTabs: FC<JobReviewStatusTabsProps> = ({ onChange, statusCounts }) => {
  const selectedReviewTab = useAppSelector(selectSelectedReviewTab);
  const statusTabs = baseStatusTabs.map(tab => ({
    ...tab,
    count: statusCounts[tab.status as JobReviewTabStatus]
  }));

  return (
    <div id="job-review-status-tabs" className="flex w-full">
      {statusTabs.map((tab, index) => {
        const isSelected = tab.status === selectedReviewTab;

        return (
          <button
            key={tab.status}
            className={`
              relative flex flex-1 flex-col items-start gap-1 px-[30px] py-3
              ${
                isSelected
                  ? 'border-x border-t-[6px] border-secondary'
                  : 'border-x border-b border-t-[3px] border-x-[#E7E7E7] border-b-secondary bg-[#ECF1F780] opacity-80'
              }
              ${index === 0 ? 'border-l-0' : ''}
              ${index === statusTabs.length - 1 ? 'border-r-0' : ''}
            `}
            style={{ borderTopColor: tab.color }}
            onClick={() => onChange(tab.status)}>
            <div className="flex items-center gap-2">
              <span className="text-sm" style={{ color: tab.color }}>
                •
              </span>
              <span
                className={`text-sbase ${
                  isSelected ? 'font-bold text-primaryText' : 'font-semibold text-accentText'
                } `}>
                {tab.label}
              </span>
            </div>
            <span className="text-17px font-bold text-[#464646]">{tab.count} Jobs</span>
          </button>
        );
      })}
    </div>
  );
};

export default JobReviewStatusTabs;
